// @ngInject
function DepartmentsApiService(ResourcesService) {

    var endpoint = 'departments';

    return {
        getPage: ResourcesService.apiFactory.get(endpoint + '/page'),
        getDepartment: ResourcesService.apiFactory.get(endpoint),
        save:  ResourcesService.apiFactory.save(endpoint + '/save', 'Department'),
        getMainGroups: ResourcesService.apiFactory.get(endpoint + '/maingroups')
    };

}

angular.module('departments.api', [])
  .factory('DepartmentsApiService', DepartmentsApiService);
